<template>
  <div class="main_color baidu_fixed">
    <div v-if="!innerWidth" class="header_box">
      <div class="header main_width">
        <div class="header_left">
          <div class="logo" @click="clickTab('/index', 1)">
            <img src="/static/images/logo.png" alt="">
          </div>
          <span>汽修宝</span>
        </div>
        <div class="h_tab_box">
          <div class="h_ul">
            <div class="h_li" @click="clickTab(item.url, item.type)" @mouseover="showDropdown(item.type)"
              @mouseleave="hideDropdown" :class="[{ 'h_li_active': h_type == item.type }, { 'h_li_select': item.type == 2 }]"
              v-for="(item, index) in h_tab_li" :key="item.type">
              {{ item.name }}
              <img v-if="item.type == 2 && dropdownVisible !== item.type" src="../../static/images2/down.png" alt="">
              <img v-if="item.type == 2 && dropdownVisible === item.type" src="../../static/images2/down_active.png" alt="">
              <!-- 下拉框 -->
              <div v-if="item.dropdown && dropdownVisible === item.type" class="dropdown-content">
                <div v-for="subItem in item.subMenu" :key="subItem.type" :class="subItem.type == subType && 'menu_item_active'"
                  @click.stop="clickTab(subItem.url, subItem.type)">
                  {{ subItem.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="h_phone"><img src="../../static/images2/h_phone.png" alt="汽修宝">020-36328593</div>
      </div>
    </div>
    <!-- H5  导航栏 -->
    <div v-else class="h5_header_box">
      <div class="h5_header h5_fixed">
        <div class="logo" @click="clickTab('/index', 1)">
          <img src="/static/images/logo.png" alt="">
          汽修宝
        </div>
        <div class="h_right">
          <div id="dow_app" class="dow" v-if="!IsPC()" @click="download">下载App</div>
          <img class="more" src="/static/images2/more.png" alt="" @click="handelOpen">
        </div>
      </div>
      <!-- 弹窗 -->
      <div class="h5_popup" v-if="isShow">
        <div class="h5_header">
          <div class="logo" @click="clickTab('/index', 1)">
            <img src="/static/images/logo.png" alt="">
            汽修宝
          </div>
          <img class="clear" src="/static/images2/clear.png" alt="" @click="isHide">
        </div>
        <div class="list">
          <div class="list_left">
            <div v-for="(item, index) in h_tab_li" :key="index" class="item" :class="[{ 'active': h_type == item.type }, { 'h_li_select': item.type == 2 }]" @click="clickTab(item.url, item.type)">{{ item.name }}</div>
          </div>
          <div class="list_right">
            <div class="list_right_title">{{ h_tab_li[h_type - 1].name }}</div>
            <template v-if="h_tab_li[h_type - 1].dropdown">
              <div class="list_right_item" v-for="(subItem, subIndex) in h_tab_li[h_type - 1].subMenu" :key="subIndex" @click="clickTab(subItem.url, subItem.type)">
                <span v-if="!subItem.h5Hid">{{ subItem.name }}</span>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isMinView, onEventGsIdo } from '../utils/index.js'
export default {
  props: {
    type: {
      type: [String, Number]
    },
    subType: {
      type: [String, Number]
    },
  },
  data() {
    return {
      h_tab_li: [{
        name: '首页',
        url: '/index',
        type: 1,
        dropdown: false,
      }, {
        name: '产品与服务',
        url: '/businessCooperation',
        type: 2,
        dropdown: true,
        subMenu: [
          { name: '汽修宝', url: '/QXB', type: 5 },
          { name: '数字云仓系统', url: '/cloudWarehouse', type: 6 },
          { name: 'API数据对接服务', url: '/dockingService', type: 8 },
          { name: '源车件商城', url: 'http://qp11.com/#/', type: 9, h5Hid: true }
        ]
      }, {
        name: '商务合作',
        url: '/productService',
        type: 3,
        dropdown: false,
      }, {
        name: '关于汽修宝',
        url: '/about',
        type: 4,
        dropdown: false,
      }],
      h_type: 1,
      nowPath: '/index',
      dropdownVisible: null, // 控制下拉框显示

      innerWidth: isMinView(),
      isShow: false
    }
  },
  components: {

  },
  watch: {
    nowPath() { }
  },
  created() {
    console.log(this.type)
    console.log(this.$route.query)
    var _this = this
    switch (_this.$route.path) {
      case '/index':
        _this.h_type = 1
        break;
      case '':
        _this.h_type = 2
        break;
      case '/productService':
        _this.h_type = 3
        break;
      case '/about':
        _this.h_type = 4
        break;
      case '/QXB':
        _this.h_type = 5
        break;
      default:
        _this.h_type = 1
    }
    _this.h_type = _this.type
  },
  mounted() {

  },
  methods: {
    // 切换tab
    clickTab(url, type) {
      if(type == 9) {
        window.open(url)
        return
      }
      this.h_type = type
      if(type == 2) return
      this.isHide()
      this.$router.push({
        path: url
      })
    },
    // 显示下拉框
    showDropdown(type) {
      this.dropdownVisible = type;
    },
    // 隐藏下拉框
    hideDropdown() {
      this.dropdownVisible = null;
    },
    handelOpen() {
      this.isShow = true;
      document.body.style.overflow = 'hidden';
    },
    isHide() {
      this.isShow = false;
      document.body.style.overflow = '';
    },
    IsPC () {
        let userAgentInfo = navigator.userAgent
        let Agents = [
            'Android', 'iPhone',
            'SymbianOS', 'Windows Phone',
            'iPad', 'iPod'
        ]
        let flag = true
        for (var i = 0; i < Agents.length; i++) {
            /* eslint-disable */
            if (userAgentInfo.indexOf(Agents[i]) != -1) {
                flag = false
                break
            }
        }
        return flag
    },
    download () {
        onEventGsIdo('qxb_$dow_app', '下载app')
        let u = navigator.userAgent;
        let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

        if (this.IsPC()) {
            // http://www.qixiubao.cn/static/QiXiuBaoInst.exe
        } else {
            if (isAndroid) {
                location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.qp333.car&channel=0002160650432d595942&fromcase=60001'
            } else if (isiOS) {
                location.href = 'https://itunes.apple.com/cn/app/%E6%B1%BD%E4%BF%AE%E5%AE%9D-%E6%9C%89%E8%BD%A6%E5%BF%85%E7%94%A8-%E4%B8%93%E4%B8%9A%E6%B1%BD%E8%BD%A6%E6%95%B0%E6%8D%AE%E8%BF%99%E9%87%8C%E5%85%A8%E9%83%BD%E6%9C%89/id790742168?mt=8'

            }
        }
    },
  }
}
</script>

<style lang="less" scoped>
@import "../assets/style/utils.less";
.h5_header {
  display: none;
}
.header_box {
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  // height: 60px;
  padding: .px2vw(12)[@result] 0;
  color: #1D2129;

  .header {
    background-color: #fff;
    margin: 0 auto;
    /*background-color: navajowhite;*/
    // height: 60px;
    display: flex;
    // justify-content: space-between;
    align-items: center;
    width: .px2vw(1280)[@result];

    .header_left {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: .px2vw(20)[@result];
      margin-right: .px2vw(80)[@result];

      .logo {
        width: .px2vw(36)[@result];
        height: .px2vw(36)[@result];
        cursor: pointer;

        img {
          width: .px2vw(36)[@result];
          height: .px2vw(36)[@result];
          border-radius: 4px;
        }
      }

      span {
        margin-left: .px2vw(8)[@result];
      }
    }

    .h_tab_box {
      font-size: .px2vw(18)[@result];
      text-align: right;

      .h_ul {
        .h_li {
          float: left;
          margin-right: .px2vw(40)[@result];
          cursor: pointer;
          font-size: .px2vw(14)[@result];
        }

        .h_li:hover {
          color: #1973bf;
          position: relative;
        }

        .h_li_active {
          color: #165DFF;
          // font-weight: 600;
          position: relative;

          &:after {
            width: 100%;
            height: 2px;
            background: #165DFF;
            content: '';
            position: absolute;
            bottom: .px2vw(-20)[@result];
            left: 50%;
            transform: translate(-50%, 0);
          }
        }

        .h_li_select {
          display: flex;
          align-items: center;

          img {
            width: .px2vw(12)[@result];
            height: .px2vw(12)[@result];
            margin-left: .px2vw(4)[@result];
          }

          &:after {
            display: none;
          }
        }

        .dropdown-content {
          position: absolute;
          top: 100%;
          left: 0;
          background: #FFFFFF;
          box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #E5E6EB;
          z-index: 1000;
          min-width: .px2vw(200)[@result];
          padding: .px2vw(10)[@result] 0;
          text-align: left;
          color: #1D2129;

          div {
            padding: .px2vw(8)[@result] .px2vw(16)[@result];
            cursor: pointer;

            &:hover {
              background-color: #E8F3FF;
            }
          }
          .menu_item_active {
            background-color: #E8F3FF;
            color: #165DFF;
          }
        }
      }
    }

    .h_phone {
      line-height: .px2vw(36)[@result];
      font-weight: 500;
      font-size: .px2vw(16)[@result];
      color: #165DFF;
      text-align: right;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      img {
        height: .px2vw(20)[@result];
        width: .px2vw(20)[@result];
        margin-right: .px2vw(8)[@result];
      }
    }
  }
}

.content_box {
  background-color: darkmagenta;
}
// 百度app浏览器会篡改代码
.baidu_fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
}

@media screen and (max-width: 900px) {
  div {
    box-sizing: border-box;
  }
    .h5_header_box {
      min-height: .h5px2vw(88)[@result];
    }
    .h5_header {
      font-weight: 500;
      padding: .h5px2vw(12)[@result] .h5px2vw(24)[@result];
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #ffffff;
      .logo {
        font-size: .h5px2vw(32)[@result];
        line-height: .h5px2vw(64)[@result];
        img {
          width: .h5px2vw(64)[@result];
          height: .h5px2vw(64)[@result];
          border-radius: .h5px2vw(8)[@result];
          margin-right: .h5px2vw(16)[@result];
        }
      }
      .h_right {
        display: flex;
        align-items: center;

      }
      .dow {
        width: .h5px2vw(164)[@result];
        height: .h5px2vw(56)[@result];
        line-height: .h5px2vw(56)[@result];
        text-align: center;
        border-radius: .h5px2vw(4)[@result];
        background: #165DFF;
        color: #ffffff;
        margin-right: .h5px2vw(40)[@result];
        font-size: .h5px2vw(26)[@result];
      }
      .more {
        width: .h5px2vw(38)[@result];
        height: .h5px2vw(40)[@result];
      }
    }
    .h5_fixed {
      position: fixed;
      z-index: 2;
      left: 0;
      right: 0;
    }
    .h5_popup {
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: #ffffff;
      z-index: 11;
      font-size: .h5px2vw(28)[@result];
      display: flex;
      flex-direction: column;
      overflow: hidden;
      .clear {
        width: .h5px2vw(48)[@result];
        height: .h5px2vw(48)[@result];
      }
      .list {
        display: flex;
        flex: 1;
        .list_left {
          width: .h5px2vw(296)[@result];
          flex: 0 0 .h5px2vw(296)[@result];
          background: #DCEDFF;
          & > div {
            padding: .h5px2vw(36)[@result] .h5px2vw(24)[@result];
            border-left: .h5px2vw(6)[@result] solid #DCEDFF;
          }
          & > .active {
            color: #165DFF;
            border-left: .h5px2vw(6)[@result] solid #165DFF;
          }
        }
        .list_right {
          padding: .h5px2vw(34)[@result] .h5px2vw(32)[@result];
          .list_right_title {
            font-weight: 700;
            font-size: .h5px2vw(32)[@result];
            margin-bottom: .h5px2vw(34)[@result];
          }
          .list_right_item {
            padding: .h5px2vw(36)[@result] .h5px2vw(24)[@result];
          }
        }
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue